import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Card from 'widgets/Card/Card';
import Rating from 'widgets/Rating/Rating';

const trimNumber = (num) => (
  Number(num) > 1000
    ? '999+'
    : num
);

export class ReviewSummary extends PureComponent {
  static propTypes = {
    summary: PropTypes.object.isRequired,
  };

  render() {
    const { summary = {} } = this.props;
    const {
      averageRating,
      numberOfReviews,
      recommendedVotes,
      oneStarReviews,
      twoStarReviews,
      threeStarReviews,
      fourStarReviews,
      fiveStarReviews,
    } = summary;

    const recommendedPercentage = Math.ceil((recommendedVotes / numberOfReviews) * 100);

    return (
      <Card className="bop-reviewSummary">
        <div
          className="bop-reviewSummary__kpi bop-reviewSummary__averageRating"
          itemProp="aggregateRating"
          itemScope=""
          itemType="http://schema.org/AggregateRating"
        >
          <span
            itemProp="ratingValue"
            className="bop-reviewSummary__kpiBall bop-reviewSummary__kpiBall--primary"
          >
            {Number(averageRating)
              .toFixed(1)}
          </span>
          <meta itemProp="ratingCount" content={trimNumber(numberOfReviews)} />
          <div className="bop-reviewSummary__kpiBallDescription">
            <Rating
              large
              withoutTitle
              reviewStats={{ averageRate: averageRating }}
            />
          </div>
        </div>
        <div className="bop-reviewSummary__stats">
          {[
            fiveStarReviews,
            fourStarReviews,
            threeStarReviews,
            twoStarReviews,
            oneStarReviews,
          ].map((rating, index) => (// eslint-disable-next-line
            <div key={index} className="bop-reviewSummary__elementWrapper">
              <Rating black reviewStats={{ averageRate: 5 - index }} />
              <Rating
                progressBar
                reviewStats={{
                  averageRate: (rating / numberOfReviews) * 5,
                }}
              />
              <span className="bop-reviewSummary__numberOfSpecificVotes">{rating}</span>
            </div>),
          )}
        </div>
        <div className="bop-reviewSummary__kpi bop-reviewSummary__reviewsNumber">
          <span
            itemProp="ratingCount"
            className={classNames(
              'bop-reviewSummary__kpiBall',
              { 'bop-reviewSummary__kpiBall--longText': Number(numberOfReviews) > 1000 },
            )}
          >
            {trimNumber(numberOfReviews)}
          </span>
          <div className="bop-reviewSummary__kpiBallDescription">
            Customers rated this product
          </div>
        </div>
        <div className="bop-reviewSummary__kpi bop-reviewSummary__recommendationsNumber">
          <div
            className={classNames(
              'bop-reviewSummary__kpiBall',
              { 'bop-reviewSummary__kpiBall--longText': recommendedPercentage === 100 },
            )}
          >
            { recommendedPercentage }
            <span className="bop-reviewSummary__recommendationsPercent">%</span>
          </div>
          <div className="bop-reviewSummary__kpiBallDescription">
            Customers would recommend this product
          </div>
        </div>
      </Card>
    );
  }
}
